;(function initFeatureCards() {
  const run = () => {
    const sections = document.querySelectorAll('[data-feature-cards]')

    if (!sections.length) return

    sections.forEach((section, sectionIndex) => {
      if (section.dataset.featureCardsInitialized) return
      section.dataset.featureCardsInitialized = 'true'

      const cards = section.querySelectorAll('[data-feature-card]')

      if (!cards.length) return

      const firstCard = cards[0]
      const contentEl = firstCard.querySelector('[data-feature-content]')
      const isMobile = window.innerWidth <= 767

      if (!isMobile || cards.length <= 1) {
        return
      }

      const features = Array.from(cards).map(
        (card) => card.querySelector('[data-feature-content]').innerHTML,
      )

      let currentIndex = 0
      let interval

      function showFeature(index) {
        // Read the other cards live: their text can change after load (the
        // shipping card follows the cart). The first card is the display, so
        // its own text comes from the copy taken at start.
        const tempEl = document.createElement('div')
        tempEl.innerHTML =
          index === 0
            ? features[0]
            : cards[index].querySelector('[data-feature-content]').innerHTML

        contentEl.classList.add(
          'opacity-0',
          'transition-opacity',
          'duration-800',
        )

        setTimeout(() => {
          // Update text without replacing container
          const newContent = tempEl.children
          const oldContent = contentEl.children
          for (let i = 0; i < oldContent.length; i++) {
            oldContent[i].textContent = newContent[i]?.textContent || ''
          }
          // A live dispatch card as the first card: its copy from the start is
          // out of date, so work it out now; dispatch.js leaves this display
          // alone while it shows another card.
          contentEl.dataset.featureShowing = index
          if (index === 0 && contentEl.dataset.dispatch) window.htwhDispatch?.fill(contentEl)

          contentEl.classList.remove('opacity-0')
        }, 800)
      }

      function startRotation() {
        if (!interval) {
          interval = setInterval(() => {
            // A size switch swaps this section out: stop the old timer.
            if (!section.isConnected) {
              stopRotation()
              observer.disconnect()
              return
            }
            currentIndex = (currentIndex + 1) % features.length
            showFeature(currentIndex)
          }, 6000)
        }
      }

      function stopRotation() {
        if (interval) {
          clearInterval(interval)
          interval = null
        }
      }

      // Swipe handling
      let touchStartX = 0
      let touchEndX = 0

      firstCard.addEventListener('touchstart', (e) => {
        stopRotation()
        touchStartX = e.changedTouches[0].screenX
      })

      firstCard.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX
        handleSwipe()
        startRotation()
      })

      function handleSwipe() {
        if (touchEndX < touchStartX - 50) {
          currentIndex = (currentIndex + 1) % features.length
          showFeature(currentIndex)
        } else if (touchEndX > touchStartX + 50) {
          currentIndex = (currentIndex - 1 + features.length) % features.length
          showFeature(currentIndex)
        }
      }

      // IntersectionObserver to start/stop based on visibility
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              startRotation()
            } else {
              stopRotation()
            }
          })
        },
        { threshold: 0.2 },
      )

      observer.observe(section)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run)
  } else {
    run()
  }
  // cardo swaps the product info in place on a size switch; start the new cards.
  document.addEventListener('cardo:render', run)
})()
